export const UPGRADE_PRODUCTS = Object.freeze({
  verified: 1,
  credit_checks: 2,
});
